(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hire-product-section"]) return;
  try {
    
var $grid = $('.gridz').isotope({
  itemSelector: '.grid-itemz',
  layoutMode: 'fitRows'
});

// CLICK FILTER
$('.filter-button-group').on('click', 'button', function () {
  var filterValue = $(this).attr('data-filter');

  $grid.isotope({ filter: filterValue });

  // Active state
  $('.filter-button-group button').removeClass('is-checked');
  $(this).addClass('is-checked');

  // Update URL hash (clean UX)
  if (filterValue === '*') {
    history.replaceState(null, null, ' ');
  } else {
    window.location.hash = filterValue.replace('.', '');
  }
});

// HASH FILTER (on load + change)
function filterByHash() {
  var hash = window.location.hash.replace('#', '');

  if (hash) {
    var filterValue = '.' + hash;

    $grid.isotope({ filter: filterValue });

    $('.filter-button-group button').removeClass('is-checked');
    $('.filter-button-group button[data-filter="' + filterValue + '"]').addClass('is-checked');
  } else {
    $grid.isotope({ filter: '*' });

    $('.filter-button-group button').removeClass('is-checked');
    $('.filter-button-group button[data-filter="*"]').addClass('is-checked');
  }
}

// INIT
$(document).ready(function () {
  filterByHash();
});

// HASH CHANGE
$(window).on('hashchange', function () {
  filterByHash();
});

  } catch(e) { console.error(e); }
})();
})();
